var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btnDiv"},[_c('el-button',{attrs:{"type":"primary","size":"small","plain":""},on:{"click":_vm.handleDownloadPdfClick}},[_vm._v("导出PDF")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }